import React from 'react';

import { Drawer as ChakraDrawer } from '@chakra-ui/react';

import { DrawerProps } from './types';

export const Drawer = ({ children, ...restProps }: DrawerProps) => {
  return <ChakraDrawer {...restProps}>{children}</ChakraDrawer>;
};
